import type { IconName, PhosphorIconName } from '@/components/atomic/icon'

import {
  ModelSectionCardContainer,
  ModelSectionCardContent,
  ModelSectionCardHeader,
} from './styles'

export interface ModelSectionCardProps {
  title: string
  description: string
  headerContent?: React.ReactNode
  children?: React.ReactNode
  icon?: IconName | PhosphorIconName
  isPhosphor?: boolean
  iconColor?: string
  iconBackgroundColor?: string
  required?: boolean
  toggleable?: boolean
  isToggleChecked?: boolean
  onToggleChange?: (checked: boolean) => void
}

// biome-ignore lint/style/noDefaultExport: Existing default export — prefer named exports for new code
export default function ModelSectionCard({
  title,
  description,
  headerContent,
  children,
  icon,
  isPhosphor,
  iconColor,
  iconBackgroundColor,
  required = false,
  toggleable = false,
  isToggleChecked = true,
  onToggleChange,
}: ModelSectionCardProps) {
  const handleToggleChange = (checked: boolean) => {
    if (onToggleChange) {
      onToggleChange(checked)
    }
  }

  const shouldShowContent = !toggleable || isToggleChecked

  return (
    <ModelSectionCardContainer>
      <ModelSectionCardHeader
        title={title}
        description={description}
        headerContent={headerContent}
        icon={icon}
        isPhosphor={isPhosphor}
        iconColor={iconColor}
        iconBackgroundColor={iconBackgroundColor}
        required={required}
        toggleable={toggleable}
        isToggleChecked={isToggleChecked}
        onToggleChange={handleToggleChange}
      />
      {children && shouldShowContent && (
        <ModelSectionCardContent>{children}</ModelSectionCardContent>
      )}
    </ModelSectionCardContainer>
  )
}
